export const patient = ({ patient }) => patient



// WEBPACK FOOTER //
// ./src/store/getters/patient.js